import React, { useCallback } from 'react';
import cn from 'classnames';
import PT from 'prop-types';
import plus from '../assets/plusBtn.svg';

const Button = ({
  text = '',
  icon,
  variant = '',
  disabled,
  onClick,
  className,
  type = 'button',
  dataTestId,
  children,
}) => {
  const handleClick = useCallback((e) => onClick && onClick(e), [onClick]);

  let iconElem = null;
  switch (icon) {
    case 'plus':
      iconElem = <img src={plus} alt="Plus" />;
      break;
    default:
      break;
  }

  return (
    <button
      data-testid={dataTestId}
      disabled={disabled}
      className={cn(
        'button',
        {
          button_primary: variant === 'primary',
          button_secondary: variant === 'secondary',
          button_simple: variant === 'simple',
          'button__no-icon': !Boolean(icon),
          button_disabled: disabled,
        },
        className
      )}
      onClick={handleClick}
      type={type}
    >
      {text}
      {children}
      {iconElem && <span className="button__icon-wrap">{iconElem}</span>}
    </button>
  );
};

Button.propTypes = {
  text: PT.oneOfType([PT.string, PT.number]),
  icon: PT.string,
  variant: PT.oneOf(['primary', 'secondary', 'simple']),
  disabled: PT.bool,
  onClick: PT.func,
  className: PT.string,
  type: PT.oneOf(['submit', 'reset', 'button']),
};

export default Button;
